import ComponentPlaceholder from 'components/ComponentPlaceholder';
import { LayoutContainer } from 'components/Layout';
import { getValidSitecoreLink, ScArrowLink } from 'components/SitecoreLink';
import type { Field, SitecoreBlockProps, SitecoreLink } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';

interface Props extends SitecoreBlockProps {
	fields?: {
		link?: Field<SitecoreLink>;
	};
}

export default function ContentLink({ fields, params }: Props) {
	if (!fields) {
		return null;
	}
	const link = getValidSitecoreLink(fields.link?.value);
	if (!link) {
		return (
			<ComponentPlaceholder
				componentName="ContentLink"
				description="Requires a link with text"
				className={getEditorMargin(params)}
			/>
		);
	}

	return (
		<LayoutContainer
			outerClassName={getEditorMargin(params)}
			id={params?.anchor}
		>
			<div className="max-w-col-6">
				<ScArrowLink link={link} />
			</div>
		</LayoutContainer>
	);
}
ContentLink.displayName = 'ContentLink';
